// extracted by mini-css-extract-plugin
export default {"uploadPasteBtn":"UploadPasteButton_uploadPasteBtn__1DYYv","uploadPasteBtnText":"UploadPasteButton_uploadPasteBtnText__fEiIC"};